import { render, staticRenderFns } from "./UserDocumentsList.vue?vue&type=template&id=b901bab4&scoped=true&"
import script from "./UserDocumentsList.vue?vue&type=script&lang=js&"
export * from "./UserDocumentsList.vue?vue&type=script&lang=js&"
import style0 from "./UserDocumentsList.vue?vue&type=style&index=0&id=b901bab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b901bab4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/kreston-is.sdev.cz/httpdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b901bab4')) {
      api.createRecord('b901bab4', component.options)
    } else {
      api.reload('b901bab4', component.options)
    }
    module.hot.accept("./UserDocumentsList.vue?vue&type=template&id=b901bab4&scoped=true&", function () {
      api.rerender('b901bab4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/parts/dashboard/UserDocumentsList.vue"
export default component.exports